import swap from './swap'
import npxs from '@/connect/abi/kovan/npxs'

// TODO 去获取mainnet链的 swap和npxs abi
export default {
  swap: {
    address: '0x5AE1b41D1598Ae6c3AD716eCf14f55cf301c3bD0',
    abi: swap
  },
  npxs: {
    address: '0xa15c7ebe1f07caf6bff097d8a589fb8ac49ae5b3',
    abi: npxs
  }
}
